import Cookies from 'js-cookie'
var config = require('./../../package.json').config;
var NODE_ENV = "production";
var ENV_CONFIG = config[NODE_ENV];

export const getParameterByName = (name, url) => {
    if (!url) url = window.location.href;
    else url = decodeURIComponent(url);
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const serializeToQueryString = params => {
    return Object.keys(params)
        .map(item => `${item}=${params[item]}`)
        .join('&');
};

export const genScratchProjectH5Link = params => {
    return `${window.location.protocol}//${
        window.location.hostname
        }/scratch3Project.html?${serializeToQueryString(params)}`;
};

export const getCookie = name => {
    var arr,
        reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) {
        return arr[2];
    } else {
        return null;
    }
};

export const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

export const deleteCookie = (name) => {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export const isWechatPlatform = () => {
    return window.navigator.userAgent.toLowerCase().includes('micromessenger');
};

const getLoginUrl = () => {    
    return `${ENV_CONFIG.links.login}`;
};

export const isUserLogin = () => {
    try {
        let userInfo = JSON.parse(decodeURIComponent(Cookies.get('l_p_cc_0')));

        return !!userInfo;
    } catch (e) {
        return false;
    }
};

export const getHeadIcon = () => {
    return getCookie('headIcon');
}

export const checkLoginStatus = redirectUrl => {
    if (isUserLogin()) return true;
    setTimeout(() => {
        let returnUrl = redirectUrl || location.href;
        window.location.href = `${getLoginUrl()}`;
    }, 100);
    return false;
};

export const goLogin = redirectUrl =>{
    removeItem('l_p_cc_0');
    setTimeout(() => {
        window.location.href = `${getLoginUrl()}`;
    }, 100);
}

export const getUserInfo = () => {
    try {
        return JSON.parse(decodeURIComponent(getCookie('l_p_cc_0')));
    } catch (e) {
        return null;
    }
};

export const removeItem = key => localStorage.removeItem(key);

export const base64ToArrayBuffer = (base64) => {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

export const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

export const isEmptyObject = obj => {
    for (let key in obj) {
        return false;
    }
    return true;
}

export const ExceptionError = function (error) {
    const { type, message } = error;
    this.type = type;
    this.message = message;
}
